const previous_projectid = (payload) => {
  return {
    type: "preporjectid",
    payload,
  };
};

export default previous_projectid;
